export const routes = {
  editAddress: `/account/contactdetails/address/edit/:accountNumber`,
} as const

export const getEditAddressRoute = (accountNumber = '') =>
  routes.editAddress.replace(':accountNumber', accountNumber)
